import { render, staticRenderFns } from "./BarConsultationsISTByTypeVisite.vue?vue&type=template&id=45bf3698&"
import script from "./BarConsultationsISTByTypeVisite.vue?vue&type=script&lang=ts&"
export * from "./BarConsultationsISTByTypeVisite.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports